/** @format */

import { CommonModule } from '@angular/common';
// Components
import { HomefieldProductTitleComponent } from './product-title.component';
import { NgModule } from '@angular/core';

@NgModule({
  imports: [CommonModule],
  declarations: [HomefieldProductTitleComponent],
  exports: [HomefieldProductTitleComponent],
})
export class HomefieldProductTitleModule {}
